module.exports = __webpack_public_path__ + "img/placenta-partial.c39d67bc.png";